<div *ngIf="loading" class="loading" aria-live="polite">
  <mat-spinner diameter="36"></mat-spinner>
  <span>正在打开文章…</span>
</div>

<form [formGroup]="form" class="editor-page">
  <header class="editor-header">
    <div class="editor-header__meta">
      <button
        class="icon-button"
        type="button"
        (click)="goBack()"
        aria-label="返回文章列表"
        title="返回文章列表"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>

      <span
        class="status-chip"
        [class.status-chip--published]="post?.is_published"
      >
        <span class="status-chip__dot"></span>
        {{ post?.is_published ? "已发布" : "草稿" }}
      </span>

      <span
        class="save-state"
        [class.save-state--error]="saveError"
        [class.save-state--dirty]="form.dirty && !saving"
      >
        <mat-icon [class.anmi-pluse]="saving">{{ saveStateIcon }}</mat-icon>
        {{ saveStateLabel }}
      </span>
    </div>

    <div class="editor-header__main">
      <div class="editor-header__info">
        <input
          class="editor-header__title"
          name="title"
          id="title"
          formControlName="title"
          placeholder="输入文章标题"
          autocomplete="off"
        />
        <input
          class="editor-header__description"
          name="description"
          id="description"
          formControlName="description"
          placeholder="添加一句简短摘要…"
          autocomplete="off"
        />
      </div>

      <div class="editor-header__actions">
        <button
          class="action-button action-button--secondary"
          type="button"
          (click)="handleSave()"
          [disabled]="form.invalid || isBusy || !form.dirty"
        >
          <mat-icon>save</mat-icon>
          保存
        </button>
        <button
          class="action-button action-button--primary"
          type="button"
          (click)="publishPost()"
          [disabled]="form.invalid || isBusy"
        >
          <mat-icon>{{ publishing ? "sync" : "publish" }}</mat-icon>
          {{ publishing ? "发布中" : post?.is_published ? "更新发布" : "发布" }}
        </button>
        <button
          *ngIf="post?.is_published"
          class="action-button action-button--danger"
          type="button"
          (click)="unpublishPost()"
          [disabled]="isBusy"
        >
          <mat-icon>{{ unpublishing ? "sync" : "unpublished" }}</mat-icon>
          {{ unpublishing ? "处理中" : "取消发布" }}
        </button>
      </div>
    </div>
  </header>

  <main class="content-wrapper">
    <app-md-editor formControlName="draft">
      <button
        class="toolbar-save"
        type="button"
        slotToolbarRight
        [class.toolbar-save--saving]="saving"
        [disabled]="form.invalid || isBusy || !form.dirty"
        (click)="handleSave()"
        aria-label="保存文章"
        title="保存文章"
      >
        <mat-icon [class.anmi-pluse]="saving">{{ saveStateIcon }}</mat-icon>
      </button>
    </app-md-editor>
  </main>
</form>
